export const LogoMark = ({ className = "h-10 w-10 shrink-0", light = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="10" fill={light ? "#ffffff" : "#0E2A47"} />
    <path d="M12 47C17 32 28 22 42 21" fill="none" stroke="#FF6F4F" strokeWidth="4" strokeLinecap="round" />
    <path d="m33 13 8 7 10-5c3-1 5 1 2 4l-8 7 1 11-4 2-5-10-7 4-4-2 8-7-4-9Z" fill={light ? "#1565D8" : "#ffffff"} />
    <circle cx="12" cy="47" r="3" fill={light ? "#1565D8" : "#ffffff"} />
  </svg>
);

export const Logo = ({ testId = "brand-logo", light = false }) => (
  <span className="brand-lockup flex items-center gap-2.5" data-testid={testId}>
    <LogoMark light={light} />
    <span className="leading-none">
      <span className={`brand-wordmark block font-display font-extrabold ${light ? "text-white" : "text-ink"}`}>
        ReserveCheap<span className={light ? "text-[#FFAD97]" : "text-brand"}>Flights</span>
      </span>
      <span className={`mt-1.5 block text-[10px] font-semibold ${light ? "text-white/70" : "text-slate-500"}`}>reservecheapflights.com</span>
    </span>
  </span>
);